import * as React from "react";
const OrangeRightIcon = (props) => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx={12.7218}
      cy={12.7707}
      r={12.1043}
      transform="rotate(-180 12.7218 12.7707)"
      fill="#FF9500"
    />
    <path
      d="M10.9813 16.1562L14.4397 12.6979L10.9813 9.23948"
      stroke="url(#paint0_linear_4969_29267)"
      strokeWidth={1.51304}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4969_29267"
        x1={12.5567}
        y1={16.1563}
        x2={2.39732}
        y2={7.44625}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="#F4F4F4" />
      </linearGradient>
    </defs>
  </svg>
);
export default OrangeRightIcon;
